export const LETTER_TEMPLATE_LANGUAGES = [
  { label: "Spanish", value: "es" },
  { label: "German", value: "de" },
  { label: "Vietnamese", value: "vi" },
  { label: "French", value: "fr" },
  { label: "Russian", value: "ru" },
];

export const LETTER_TEMPLATE_DEVICE_TYPES = [
  { label: "Pacemaker", value: "Pacemaker" },
  { label: "ICD", value: "ICD" },
  { label: "ILR", value: "ILR" },
];

export const TRANSMISSION_CYCLE_OPTIONS = [
  { label: "31 Days", value: "31" },
  { label: "91 Days", value: "91" },
];

export const DEFAULT_MISSING_TRANSMISSIONS = {
  active: false,
  transmissionCycle: "",
  useSavedNextSendCycle: false,
};

export const DEFAULT_LETTER_TEMPLATE_VALUES = {
  templateName: "",
  accounts: [],
  deviceModels: [],
  manufacturerArr: [],
  showBattery: false,
  customNextSend: false,
  associatedDevices: "",
  missingTransmissions: DEFAULT_MISSING_TRANSMISSIONS,
  primaryTemplate: "",
  translations: [],
};

export const createNewTranslation = () => ({
  id: `translation_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`,
  language: "",
  content: "",
});

export const getLanguageLabel = (languageValue) =>
  LETTER_TEMPLATE_LANGUAGES.find(
    (lang) => lang.value === languageValue?.toLowerCase()
  )?.label ||
  languageValue ||
  "";
